<template>
  <div>
    <div v-if="isLoading">
      <p>Loading...</p>
    </div>
    <div class="scenes" v-if="selectedProject">
      <div
        v-for="(scene, index) in scenes"
        :key="scene._id"
        :class="['scene', { 'no-margin': type === 'scene'} ]"
      >
        <img
          ref="myDraggable"
          v-if="draggable"
          draggable="true"
          :src="scene.imageSmall"
          class="drag-drop draggable-image"
          :data-id="scene._id"
        />
        <div class="scene__name">
          <span>
            <span class="scene--unsaved" v-if="isUnsaved(scene._id)">*</span>
            {{ scene.name }}
          </span>
        </div>
        <div class="scene__preview">
          <InfographicsPreview
            :scene="isUnsaved(scene._id) || scene"
            :key="scene._id + scene.imageSmall"
            :previewList="true"
          />
        </div>
        <div class="scene__actions" v-if="type === 'all' || !type">
          <div class="scene__action scene__action--right">
            <button class="button" @click="goToScene(scene._id, index)">Edit</button>
            <button
              class="button"
              :disabled="!isUnsaved(scene._id)"
              @click="saveScene(scene._id)"
            >Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import { initDraggable, getProjectScenes } from "../../utils";
import InfographicsPreview from "../../views/Editor/InfographicsPreview";
import api from "../../api";

export default {
  props: {
    type: String,
    draggable: Boolean,
    showUsed: Boolean
  },

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    ...mapState([
      "selectedProject",
      "selectedScene",
      "unsavedScenes",
      "scenes"
    ]),
    ...mapGetters(["getScenes"])
  },

  mounted() {
    if (!this.selectedProjecot) {
      this.isLoading = true;

      api.projects
        .loadProjectById(this.$route.params.id)
        .then(project => {
          this.setSelectedProject(project.data);
          this.setScenes(getProjectScenes(this.selectedProject));
          this.isLoading = false;
        })
        .catch(function(error) {
          console.log(error);
        });
    }

    if (this.draggable) {
      const draggables = this.$refs.myDraggable;

      if (draggables.length) {
        draggables.forEach(draggableItem =>
          initDraggable(draggableItem, event => {
            // eslint-disable-next-line
            console.log(event);
          })
        );
      }
    }
  },

  methods: {
    ...mapMutations([
      "setSelectedScene",
      "setSelectedProject",
      "openPopup",
      "setScenes",
      "saveUnsavedScene"
    ]),
    isUnsaved(id) {
      return this.unsavedScenes.find(s => s._id === id);
    },
    goToScene: function(id, index) {
      this.$router.push({
        name: "Scene",
        params: {
          id: this.$route.params.id,
          sid: id
        }
      });
    },
    saveScene: function(id) {
      // eslint-disable-next-line
      this.saveUnsavedScene(id);
      this.setScenes(getProjectScenes(this.selectedProject));

      api.projects
        .updateProject(this.selectedProject._id, this.selectedProject)
        .then(response => {})
        .catch(function(error) {
          console.log(error);
        });
    },
    addNewScene: function() {
      // eslint-disable-next-line
      console.log("add new");
      this.openPopup("addPage");
    }
  },
  components: {
    InfographicsPreview
  }
};
</script>

<style lang="scss" scoped>
.scenes {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
}

.is-home-control {
  position: relative;
  top: -3px;
}

.scene-preview__footer-item {
  margin-right: 10px;

  &:last-of-type {
    margin-right: 0;
  }
}

.draggable-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  user-select: none;
  z-index: 10;
  touch-action: none;

  &.is-appended {
    position: absolute;
    width: 625px;
    height: 410px;
    object-fit: contain;
  }
}

.scene {
  position: relative;
  width: calc(50% - 40px);
  margin: 15px;
  margin-left: 0;

  &--unsaved {
    color: #ff0000;
    font-size: 24px;
  }

  // .editor.sidebarIsActive & {
  //   width: calc(100% - 10px);
  // }

  &__name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    width: 100%;
    font-weight: 300;
    font-size: 22px;
    color: #333;
    padding: 0;

    button.button {
      padding: 0 10px;
    }
  }

  &__preview {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &--new {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border-style: dotted;
    border-width: 3px;
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    user-select: none;
    cursor: pointer;

    &:hover {
      h2 {
        transform: scale(1.05);
      }
    }

    h2 {
      color: rgb(190, 190, 190);
      font-size: 20px;
      font-weight: normal;
      transition: 0.3s ease;
    }
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;

    .button {
      margin-left: 5px;
    }
  }

  .project__action--left {
    .button {
      margin-left: 0;
    }
  }
}

.ml-15 {
  margin-left: 15px;
}
</style>
